// _______file detail page => 초음파, 열화상, 자외선 테이블 (표)_______
export default function FileValueTable({ type, parsedData, t, labelMap = {} }) {
  let tableHeaders = [];

  // type으로 맵핑
  switch (type) {
    case "ultrasonic":
      tableHeaders = [
        {
          value: parsedData?.avg_decibel ?? parsedData?.decibel,
          key: "avg_decibel",
          label: t("fileValueTable.ultrasonic.detected"),
          unit: "(dB)",
        },
        {
          value: parsedData?.max_decibel,
          key: "peak_decibel",
          label: t("fileValueTable.ultrasonic.max"),
          unit: "(dB)",
        },
        {
          value: parsedData?.peak_hz,
          key: "peak_hz",
          label: t("fileValueTable.ultrasonic.peakFrequency"),
          unit: "(kHz)",
        },
        {
          value: parsedData?.distance,
          key: "distance",
          label: t("fileValueTable.ultrasonic.distance"),
          unit: "(m)",
        },
      ];
      break;
    case "thermal":
      tableHeaders = [
        {
          value: parsedData?.thermal_center,
          key: "thermal_center",
          label: t("fileValueTable.thermal.detected"),
          unit: "(℃)",
        },
        {
          value: parsedData?.thermal_max,
          key: "thermal_max",
          label: t("fileValueTable.thermal.max"),
          unit: "(℃)",
        },
        {
          value: parsedData?.thermal_min,
          key: "thermal_min",
          label: t("fileValueTable.thermal.min"),
          unit: "(℃)",
        },
        {
          value: parsedData?.thermal_avg,
          key: "thermal_avg",
          label: t("fileValueTable.thermal.avg"),
          unit: "(℃)",
        },
        {
          value: parsedData?.distance,
          key: "distance",
          label: t("fileValueTable.thermal.distance"),
          unit: "(m)",
        },
      ];
      break;
    case "ultraviolet":
      tableHeaders = [
        {
          value: parsedData?.uv_detected,
          key: "uv_detected",
          label: t("fileValueTable.ultraviolet.detected"),
          unit: "",
        },
        {
          value: parsedData?.particle_count,
          key: "particle_count",
          label: t("fileValueTable.ultraviolet.particleCount"),
          unit: "(개)",
        },
        {
          value: parsedData?.max_particle_area,
          key: "max_particle_area",
          label: t("fileValueTable.ultraviolet.maxParticleArea"),
          unit: "(px²)",
        },
        {
          value: parsedData?.distance,
          key: "distance",
          label: t("fileValueTable.ultraviolet.distance"),
          unit: "(m)",
        },
      ];
      break;

    default:
      tableHeaders = [];
      return;
  }

  return (
    <table className="fileValueTable">
      <thead>
        <tr>
          {tableHeaders.map(({ key, label, unit }) => (
            <th key={key}>
              {labelMap[key] ?? label}
              <span>{unit}</span>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          {tableHeaders.map((i, idx) => {
            return <td key={idx + 1}>{i.value}</td>;
          })}
        </tr>
      </tbody>
    </table>
  );
}
